export enum OrganizationFormFieldsNames {
  Name = 'name',
}

export interface OrganizationFormFields {
  [OrganizationFormFieldsNames.Name]?: string;
}
